// src/SmartifyLogin.js
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import useDeviceId from "./useDeviceId";
import {
  FetchFromServer,
  UpdateToServer,
} from "../api/ServerApi";



const SmartifyLogin = () => {
  useDeviceId();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    const deviceId = localStorage.getItem("device_id");
    const otpVerified = localStorage.getItem("OtpVerified");

    if (userId && deviceId && otpVerified === "true") {
      navigate("/main");
    }
  }, [navigate]);

  const triggerOTPFlow = async (user) => {
    const confirmSend = window.confirm(
      "Device mismatch detected! You must verify OTP. Send OTP?"
    );

    if (!confirmSend) {
      alert("Login cancelled.");
      return;
    }

    try {
      setLoading(true);
      const otpData = await FetchFromServer(
        "SendOtpOnWhatsAppbyMobileNumber",
        {
          MobileNumber: Number(user.MobileNumber),
          ServiceBy: "Smartify Automation R",
        }
      );


      console.log("SendOtp response:", otpData);
      if (Array.isArray(otpData) && otpData.length > 0) {
        localStorage.setItem("Otp", otpData[0].Otp);
      }

      localStorage.setItem("TempUserId", user.UserId);
      localStorage.setItem("TempMobile", user.MobileNumber);
      localStorage.setItem("TempPassword", password);
      localStorage.setItem("OtpVerified", "false");

      alert("OTP sent!");
      navigate("/verify-otp");
    } catch (err) {
      console.error("Error sending OTP:", err);
      alert("Failed to send OTP. See console for details.");
    } finally {
      setLoading(false);
    }
  };

  const loginUser = async () => {
    // basic validation
    if (!mobile || !password) {
      alert("Please fill both fields.");
      return;
    }
    // optional stricter validation:
    if (!/^\d{6,15}$/.test(mobile)) {
      alert("Enter a valid mobile number (digits only).");
      return;
    }

    const localDeviceId = localStorage.getItem("device_id");
    const lastDeviceId = localStorage.getItem("LastLoginDeviceId");

    setLoading(true);
    try {
      console.log("Calling GetUserDetailsForCorporationbyMobileNumber with:", {
        MobileNumber: Number(mobile),
        Password: password,
        DeviceId: localDeviceId,
      });

      const data = await FetchFromServer(
        "GetUserDetailsForCorporationbyMobileNumber",
        {
          MobileNumber: Number(mobile),
          Password: password,
          DeviceId: localDeviceId,
        }
      );


      console.log("Login response:", data);

      if (!Array.isArray(data) || data.length === 0) {
        alert("Invalid mobile or password.");
        return;
      }
      // console.log(data);
      const user = data[0];

      if (user.Password !== password) {
        alert("Wrong password.");
        return;
      }

      // FIRST LOGIN EVER
      if (!lastDeviceId) {
        localStorage.setItem("LastLoginDeviceId", localDeviceId);
        await UpdateToServer("UpdateUsers", {
          UserId: user.UserId,
          LaptopDeviceId: localDeviceId,
        });

      }
      // DEVICE MISMATCH
      else if (lastDeviceId !== localDeviceId) {
        // start OTP flow
        return await triggerOTPFlow(user);
      }

      // proceed normal login
      localStorage.setItem("UserId", user.UserId);
      localStorage.setItem("MobileNumber", user.MobileNumber);
      localStorage.setItem("Password", password);
      localStorage.setItem("AllowTesting", user.AllowTesting);
      localStorage.setItem("Name", user.Name);
      localStorage.setItem("Surname", user.Surname);
      localStorage.setItem("SuperAdmin", user.SuperAdmin);
      localStorage.setItem("OtpVerified", "true");

      localStorage.setItem(
        "ThemeColor",
        JSON.stringify({
          back: { r: user.Back_Red, g: user.Back_Green, b: user.Back_Blue },
          button: {
            r: user.Button_Red,
            g: user.Button_Green,
            b: user.Button_Blue,
          },
        })
      );

      navigate("/main");
    } catch (err) {
      // Better error visibility
      console.error("Login error (detailed):", err);

      // If the post helper attaches response/error fields, show them
      const message =
        err?.message ||
        (err?.response && JSON.stringify(err.response)) ||
        JSON.stringify(err);
      alert(`Server error: ${message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.title}>Smartify Automation</div>

        <div style={styles.loginBox}>
          <input
            type="text"
            placeholder="Mobile Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            style={styles.input}
            disabled={loading}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            disabled={loading}
          />

          <button
            onClick={loginUser}
            style={{ ...styles.button, ...styles.login }}
            disabled={loading}
          >
            {loading ? "Please wait..." : "Login"}
          </button>

          <Link to="/ForgotPassword" style={styles.link}>
            Forgotten password?
          </Link>

          <hr />

          <button
            onClick={() => navigate("/signup")}
            style={{ ...styles.button, ...styles.create }}
            disabled={loading}
          >
            Create New Account
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  body: {
    backgroundImage:
      'url("https://wallpapers.com/images/hd/usa-chicago-riverwalk-at-night-1jaq0bwc5dc0g6n0.jpg")',
    backgroundSize: "cover",
    height: "100vh",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  title: {
    fontSize: "48px",
    color: "white",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  loginBox: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    width: "340px",
    borderRadius: "8px",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "14px",
    margin: "8px 0",
    borderRadius: "6px",
    fontSize: "16px",
  },
  button: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    fontWeight: "bold",
    borderRadius: "6px",
    cursor: "pointer",
    border: "none",
  },
  login: { backgroundColor: "#1877f2", color: "white" },
  create: { backgroundColor: "#42b72a", color: "white" },
  link: { color: "white", fontSize: "14px", marginTop: "10px" },
};

export default SmartifyLogin;
